import React from 'react';
import { LinkProps as MuiLinkProps, Link as MuiLink, LinkTypeMap } from '@mui/material';
export * from '@mui/material/Link';

export type LinkProps<RootComponent extends React.ElementType = LinkTypeMap['defaultComponent']> = MuiLinkProps<
    RootComponent,
    { endIcon?: React.ReactNode; component?: RootComponent }
>;

export function Link<C extends React.ElementType>(props: LinkProps<C>) {
    const { endIcon, ...otherProps } = props;
    return endIcon ? (
        <MuiLink
            display="inline-content"
            sx={{
                textDecorationLine: 'none',
                '& > *': {
                    verticalAlign: 'middle',
                    ':not(:first-child)': {
                        marginLeft: (theme) => theme.spacing(theme.tokens.spacing.xxxs),
                    },
                },
                '&:hover': {
                    textDecorationThickness: '2px',
                    textDecorationLine: 'underline',
                    textDecorationColor: (theme) => theme.palette.primary.main,
                    textUnderlineOffset: (theme) => theme.spacing(theme.tokens.spacing.xxs),
                },
            }}
            {...otherProps}
        >
            <span>{otherProps.children}</span>
            {endIcon}
        </MuiLink>
    ) : (
        <MuiLink {...props} />
    );
}
